const ColumnSize = [
  { percent: '22', smallSize: true, textCapitalize: true },
  { smallSize: true, textCenter: true },
  { smallSize: true, textCenter: true },
  { smallSize: true, textCenter: true },
];

export default ColumnSize;
